export const selectDocumentationTemplates = (state) => state.documentationTemplate.documentationTemplates;
export const selectDocumentationTemplateLoading = (state) => state.documentationTemplate.loading;
export const selectDocumentationTemplateError = (state) => state.documentationTemplate.error;
export const selectLetterTypes = (state) => state.documentationTemplate.letterTypes;